import { inject } from "@angular/core"
import { CanActivateFn } from "@angular/router"
import { environment } from "../../../environments/environment"
import { ClerkService } from "../services/clerk.service"

export const clerkAuthGuard: CanActivateFn = async (_route, _state) => {
  const clerkService = inject(ClerkService)

  // Ensure Clerk is initialized before checking auth
  await clerkService.initialize(environment.clerkPublishableKey)

  // Use the signal value
  if (!clerkService.isAuthenticated()) {
    // Redirect to sign-in (Clerk will handle this)
    await clerkService.openSignIn()
    return false
  }

  return true
}
